import { eduIDApi } from "./common";
export const frejaeIDApi = eduIDApi.injectEndpoints({
    endpoints: (builder) => ({
        frejaeIDVerifyIdentity: builder.query({
            query: (body) => {
                var _a;
                return ({
                    url: "verify-identity",
                    body: Object.assign(Object.assign({}, body), { frontend_action: (_a = body.frontend_action) !== null && _a !== void 0 ? _a : "verifyIdentity" }),
                });
            },
            extraOptions: { service: "frejaeID" },
        }),
        frejaeIDGetStatus: builder.query({
            query: (body) => ({
                url: "get-status",
                body,
            }),
            extraOptions: { service: "frejaeID" },
        }),
        frejaeIDMfaAuthenticate: builder.query({
            query: (body) => {
                var _a;
                return ({
                    url: "mfa-authenticate",
                    body: Object.assign(Object.assign({}, body), { frontend_action: (_a = body.frontend_action) !== null && _a !== void 0 ? _a : "loginMfaAuthn" }),
                });
            },
            extraOptions: { service: "frejaeID" },
        }),
        frejaeIDVerifyCredential: builder.query({
            query: (body) => {
                var _a;
                return ({
                    url: "verify-credential",
                    body: Object.assign(Object.assign({}, body), { frontend_action: (_a = body.frontend_action) !== null && _a !== void 0 ? _a : "verifyCredential" }),
                });
            },
            extraOptions: { service: "frejaeID" },
        }),
        frejaeIDMfaRegister: builder.query({
            query: () => ({
                url: "mfa-register",
                body: {
                    method: "freja_eid",
                    frontend_action: "signupExternalMfa",
                },
            }),
            extraOptions: { service: "frejaeID" },
        }),
    }),
});
